import React, { useEffect, useState } from 'react';
import useQueryParams from 'hooks/useQueryParams';
import { Button, Flex, Tooltip } from 'antd';

const NetworkDataSwitcher = ({ onFilter = () => {}, defaultValue, setGlobally = false }) => {
  const { setUrlParams } = useQueryParams();
  const [selectedNetworks, setSelectedNetworks] = useState(defaultValue || []);
  const networks = ['Facebook', 'Google', 'Bing', 'TikTok'];

  useEffect(() => {
    if (!defaultValue) {
      setSelectedNetworks([]);
    } else {
      setSelectedNetworks(defaultValue);
    }
  }, [defaultValue]);

  const toggleNetwork = (network) => {
    setSelectedNetworks((prev) => {
      const updated = prev.includes(network.toLowerCase())
        ? prev.filter((n) => n !== network.toLowerCase())
        : [...prev, network.toLowerCase()];
      if (setGlobally) {
        setUrlParams({ networks: updated });
      }
      onFilter(updated);
      return updated;
    });
  };

  return (
    <Flex gap='small' align='center' wrap>
      {networks.map((network) => {
        const isSelected = selectedNetworks.includes(network.toLowerCase());
        return (
          <Tooltip title={network} key={network}>
            <Button
              aria-label={`Select ${network}`}
              icon={
                <img
                  src={`/icons/networks/${network.toLowerCase()}.svg`}
                  alt={network}
                  style={{ width: 20, height: 20 }}
                />
              }
              className={
                isSelected ? 'bg-error-background border border-orange' : 'bg-background-light'
              }
              type='text'
              onClick={() => toggleNetwork(network)}
              shape='circle'
            />
          </Tooltip>
        );
      })}
    </Flex>
  );
};

export default NetworkDataSwitcher;
